import { _ as __decorate, a as __metadata } from '../tslib.es6-Cv888lzs.js';
import { queryAssignedElements, customElement } from 'lit/decorators.js';
import { ItCheckboxGroupBase } from '@italia/checkbox/it-checkbox-group-base.js';

let ItToggleGroup = class ItToggleGroup extends ItCheckboxGroupBase {
};
__decorate([
    queryAssignedElements({ selector: 'it-toggle' }),
    __metadata("design:type", Array)
], ItToggleGroup.prototype, "checkboxes", void 0);
ItToggleGroup = __decorate([
    customElement('it-toggle-group')
], ItToggleGroup);

export { ItToggleGroup };
//# sourceMappingURL=it-toggle-group.js.map
